// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"856":"971f50d6","4110":"971f50d6","6026":"971f50d6","7949":"971f50d6","9619":"971f50d6"}[chunkId] + ".chunk.css";
};